import { createContext, useContext, useState, useEffect, useCallback } from 'react';

interface AuthContextType {
  isAuthenticated: boolean;
  apiKey: string | null;
  login: (token: string, apiKey?: string) => void;
  logout: () => void;
  isLoading: boolean;
  setApiKey: (apiKey: string | null) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [apiKey, setApiKeyState] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Проверяем наличие токена при загрузке приложения
    const token = localStorage.getItem('access_token');
    setIsAuthenticated(!!token);
    setIsLoading(false);
  }, []);

  const login = (token: string, apiKey?: string) => {
    if (!apiKey) {
      throw new Error('API key is missing. Please contact support or try logging in again.');
    }
    localStorage.setItem('access_token', token);
    setIsAuthenticated(true);
    setApiKeyState(apiKey);
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    setIsAuthenticated(false);
    setApiKeyState(null);
  };

  const setApiKey = useCallback((key: string | null) => {
    setApiKeyState(key);
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, apiKey, login, logout, isLoading, setApiKey }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
